import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from '../../static/cms/translations/en/translations.json';
import fr from '../../static/cms/translations/fr/translations.json';
import es from '../../static/cms/translations/es/translations.json';
import ar from '../../static/cms/translations/ar/translations.json';
import ru from '../../static/cms/translations/ru/translations.json';
import zh from '../../static/cms/translations/zh/translations.json';

import LanguageDetector from 'i18next-browser-languagedetector';

i18next
    // .use(Fetch)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        load: 'languageOnly',
        supportedLngs: ['en', 'fr', 'es', 'ar', 'ru', 'zh'],
        fallbackLng: 'en',
        lowerCaseLng: true,
        nsSeparator: ':',
        keySeparator: '.',
        defaultNS: 'translations',
        debug: false,
        interpolation: {
            escapeValue: false
        },
        resources: {
            en: {
                translations: en
            },
            fr: {
                translations: fr
            },
            es: {
                translations: es
            },
            ar: {
                translations: ar
            },
            ru: {
                translations: ru
            },
            zh: {
                translations: zh
            }
        },
        detection: {
            order: ['htmlTag'],
            htmlTag: document.documentElement,
        }
    })

export default i18next;
